module.exports = __webpack_public_path__ + "media/images/PlaybookDiagram-0768ae71a6513971ceabec2e7fdb639b.png";